import { connect, MapStateToProps } from 'react-redux';
import { Props } from './DaApp';
import {
  getShowMatureContent,
  getIsMobile,
  getIsLoggedIn,
  getTheme,
  getThemeSkin,
  getHasJoinedWithEclipse,
  getDeviceSupportsWebp,
  getPublicSession,
  getDeviceSupportsLazy,
  getVerificationEmailAddress,
} from '../publicSession/selectors';
import { getFirstTimeFlags } from '../redux/firstTimeFlags/selectors';
import { getPageViewAndComponent } from '../biLogger/redux/selectors';
import { appMounted, appUnmounted, appVisibilityChange } from '../redux/app/actions';
import { getEnabledFlagsList } from '@wix/da-react-context/pkg/flags/redux/selectors';
import { getIsDuperbrowseActive } from '../Duperbrowse/redux/selectors';

export type StateProps = Pick<
  Props,
  | 'showMatureContent'
  | 'isMobile'
  | 'isLoggedIn'
  | 'theme'
  | 'themeSkin'
  | 'firstTimeFlags'
  | 'hasJoinedWithEclipse'
  | 'supportsWebp'
  | 'supportsLazy'
  | 'publicSession'
  | 'biPageContextData'
  | 'flags'
  | 'isDuperbrowseActive'
>;
export type DispatchProps = Pick<Props, 'appMounted' | 'appUnmounted' | 'appVisibilityChange'>;
export type OwnProps = Omit<Props, keyof Omit<DispatchProps & StateProps, 'theme' | 'themeSkin'>>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (state, ownProps) => ({
  showMatureContent: getShowMatureContent(state),
  isMobile: getIsMobile(state),
  isLoggedIn: getIsLoggedIn(state),
  theme: ownProps.theme || getTheme(state),
  themeSkin: ownProps.themeSkin || getThemeSkin(state),
  firstTimeFlags: getFirstTimeFlags(state),
  hasJoinedWithEclipse: getHasJoinedWithEclipse(state),
  supportsWebp: getDeviceSupportsWebp(state),
  supportsLazy: getDeviceSupportsLazy(state),
  publicSession: getPublicSession(state),
  biPageContextData: getPageViewAndComponent(state),
  flags: getEnabledFlagsList(state),
  verificationEmail: getVerificationEmailAddress(state),
  isDuperbrowseActive: getIsDuperbrowseActive(state),
});

const mapDispatchToProps: DispatchProps = {
  appMounted,
  appUnmounted,
  appVisibilityChange,
};

export default connect(mapStateToProps, mapDispatchToProps);
